import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sid = decodeURIComponent(m[1]);
    (async () => {
      try {
        await exchangeSession(sid);
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true });
        toast.success("Signed in with Google");
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, exchangeSession, navigate]);

  return (
    <div className="h-screen flex items-center justify-center text-slate-500 text-sm" data-testid="auth-callback-loading">
      Finishing sign-in…
    </div>
  );
}
